import React from "react"

import { Checkbox, Input } from "components"
import { productUnitsSymbol } from "constant"
import classes from "./StrrrmTableRow.module.scss"

const StrrrmTableRow = (props) => {
  const { receivedItem, setReceivedItems } = props

  const handleCheck = (checked) => {
    if (checked) {
      setReceivedItems(prev =>
        prev.map(ai =>
          ai.optionId === receivedItem.optionId
            ? { ...ai, receivedQuantity: String(ai.requestedQuantity) }
            : ai
        )
      )

      return
    }

    setReceivedItems(prev =>
      prev.map(ai =>
        ai.optionId === receivedItem.optionId
          ? { ...ai, receivedQuantity: "0" }
          : ai
      )
    )
  }

  const handleChange = (e) => {
    setReceivedItems(prev =>
      prev.map(ai =>
        ai.optionId === receivedItem.optionId
          ? { ...ai, receivedQuantity: e.target.value }
          : ai
      )
    )
  }

  const numberType =
    receivedItem.unit === "quantity" ? "int" : "float"

  const checked =
    receivedItem.receivedQuantity !== "" &&
    receivedItem.receivedQuantity !== "0"

  return (
    <tr>
      <td>
        <Checkbox
          checked={checked}
          showNotChecked
          onChange={handleCheck}
        />
      </td>
      <td>
        {receivedItem.foodName}{" "}
        {receivedItem.isSimple ? "" : receivedItem.foodOptionName}
      </td>
      <td style={{ textAlign: "center" }}>
        {receivedItem.requestedQuantity}
        {productUnitsSymbol[receivedItem.unit]}
      </td>
      <td style={{ textAlign: "center" }}>
        {receivedItem.acceptedQuantity}
        {productUnitsSymbol[receivedItem.unit]}
      </td>
      <td style={{ textAlign: "center" }}>
        <div className={classes["input-container"]}>
          <Input
            min={0}
            type="number"
            value={receivedItem.receivedQuantity}
            numberType={numberType}
            onChange={handleChange}
            className={classes["input"]}
          />
          <span>
            {productUnitsSymbol[receivedItem.unit]}
          </span>
        </div>
      </td>
    </tr>
  )
}

export default React.memo(StrrrmTableRow)